import http from './ajax';

const API_URL = {
  Submissions: '/api/Submission', //投稿清單or詳細
  Admissions: '/api/Submission/Admissions', //得獎名單
  SubmitSubmissions: '/api/Submission/Submit' //投稿
};

class submissionApi extends http {
  //投稿清單
  SubmissionList = async (params = {}) => {
    try {
      let url = `${API_URL.Submissions}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('SubmissionList', err);
    }
  };

  getSubmissionList = (params = {}) => {
    return this.SubmissionList(params);
  };

  //得獎名單
  AdmissionList = async (params = {}) => {
    try {
      let url = `${API_URL.Admissions}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('AdmissionList', err);
    }
  };

  getAdmissionList = (params = {}) => {
    return this.AdmissionList(params);
  };

  //投稿清單詳細
  SubmissionDetail = async (params = {}) => {
    try {
      let url = `${API_URL.Submissions}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('SubmissionDetail', err);
    }
  };

  getSubmissionDetail = (params = {}) => {
    return this.SubmissionDetail(params);
  };

  //投稿
  SubmitSubmissions = async (Id, params = {}) => {
    try {
      let url = `${API_URL.SubmitSubmissions}/${Id}`;
      const response = await this.postfileRequest(url, params);
      return response;
    } catch (err) {
      console.log('SubmitSubmissions', err);
    }
  };

  getSubmitSubmissions = (Id, params = {}) => {
    return this.SubmitSubmissions(Id, params);
  };
}

export default new submissionApi();



// WEBPACK FOOTER //
// ./src/service/submission.js